import type { ReactNode } from 'react';

import type { FilterKey } from '@core/Entities/Search/SearchFilters/Filter.entity';

import { MultiSelect } from 'Components/MultiSelect/MultiSelect';
import { useFilterLink } from 'Hooks/SearchFilters/UseFilterLink';
import {
  type MultiSelectOption,
  useMultiSelectFilters,
} from 'Hooks/SearchFilters/UseMultiSelectFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import { FilterLink } from '../FilterLink/FilterLink';
import { CERTIFICATES } from './EnvCertificateFilter.constants';

import styles from './EnvCertificateFilter.module.css';

type EnvCertificateFilterProps = FilterControlBaseProps;

const filterId: FilterKey = 'emission-sticker';

export const EnvCertificateFilter = ({
  strings,
  locale,
  isPlpFiltersSeoEnabled,
  tenant,
}: EnvCertificateFilterProps) => {
  const { getLinkForFilterValue } = useFilterLink({
    filterId,
    locale,
    isPlpFiltersSeoEnabled,
    tenant,
  });

  const listEnhanceFn = (envCert: MultiSelectOption, selected: string[]) => {
    const renderFn = envCert.renderLabel as (name: ReactNode) => JSX.Element;
    const link = getLinkForFilterValue({
      filterValue: envCert.id,
      resultCount: envCert.count,
    });
    return {
      ...envCert,
      renderLabel: renderFn(<FilterLink link={link}>{envCert.label}</FilterLink>),
      selected: selected?.includes(envCert.id),
    };
  };
  const { handleSelect, listWithSelected } = useMultiSelectFilters(
    filterId,
    CERTIFICATES,
    strings,
    locale,
    isPlpFiltersSeoEnabled,
    tenant,
    listEnhanceFn,
  );

  return (
    <section className={styles.envCertificateFilter}>
      <MultiSelect
        groupName="emission-sticker"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={handleSelect}
        dataTestId="env-certificate-filter-list"
      />
    </section>
  );
};
